/**
 * Base URL for the backend API.
 * Set REACT_APP_API_URL in your .env to point to the deployed backend.
 * Falls back to localhost for local development.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3001';
